import { fromJS } from 'immutable';
import * as types from '../constants';

const defaultState = fromJS({
  appStatus: true,
  shopInfo: {
    shopOwner: '',
    email: '',
    shopName: '',
    myshopifyDomain: ''
  },
  listNotification: [],
  notificationsDetail: null,
  dataSettings: {
    charge_name: 'FREE',
    charge_price: 0,
    charge_status: 'cancelled',
    count_all: 5000,
    count_email_test: 4,
    count_used: 0,
    count_view_free: 0,
    first_install_at: '2021-06-23T03:37:13Z',
    json_version: 727887,
    last_install_at: '2021-07-23T02:05:15Z',
    shop_id: 29203431529,
    status_app: false,
    status_code: 200
  },
  changeAppStatusLoading: false,
  changeAppStatusResult: 0, // trạng thái bạn đầu 0, 1 save success, 2 save error
  changeAppStatusCurrencyLoading: false,
  changeAppStatusCurrencyResult: 0, // trạng thái bạn đầu 0, 1 save success, 2 save error
  appStatusCurrency: true,
  appStatusTranslate: true,
  changeAppStatusTranslateLoading: false,
  changeAppStatusTranslateResult: 0 // trạng thái bạn đầu 0, 1 save success, 2 save error
});

const appReducer = (state = defaultState, action) => {
  switch (action.type) {
    case types.CHANGE_APP_STATUS:
      return state.set('appStatus', action.status).set('changeAppStatusLoading', true).set('changeAppStatusResult', 0);
    case types.CHANGE_APP_STATUS_RESULT:
      return state
        .set('appStatus', action.res.status)
        .set('changeAppStatusLoading', false)
        .set('changeAppStatusResult', action.res.result);

    case types.CHANGE_APP_STATUS_CURRENCY:
      return state
        .set('appStatusCurrency', action.status)
        .set('changeAppStatusCurrencyLoading', true)
        .set('changeAppStatusCurrencyLoading', 0);
    case types.CHANGE_APP_STATUS_CURRENCY_RESULT:
      return state
        .set('appStatusCurrency', action.res.status)
        .set('changeAppStatusCurrencyLoading', false)
        .set('changeAppStatusCurrencyResult', action.res.result);

    case types.RESET_CHANGE_STATUS_APP_CURRENCY_RESULT:
      return state.set('changeAppStatusCurrencyResult', 0);

    case types.CHANGE_APP_STATUS_TRANSLATE:
      return state
        .set('appStatusTranslate', action.status)
        .set('changeAppStatusTranslateLoading', true)
        .set('changeAppStatusTranslateResult', 0);
    case types.CHANGE_APP_STATUS_TRANSLATE_RESULT:
      return state
        .set('appStatusTranslate', action.res.status)
        .set('changeAppStatusTranslateLoading', false)
        .set('changeAppStatusTranslateResult', action.res.result);

    case types.RESET_CHANGE_STATUS_APP_TRANSLATE_RESULT:
      return state.set('changeAppStatusTranslateResult', 0);
    case types.GET_LIST_NOTIFICATION_RESULT:
      return state.set('listNotification', fromJS(action.payload));
    case types.GET_NOTIFICATION_DETAIL_RESULT:
      return state.set('notificationsDetail', fromJS(action.payload[0]));
    case types.GET_CURRENCY_RATE_RESPONSE:
      return state.set('getCurrencyRate', action.payload);
    case types.SET_SHOP_SETTINGS:
      return state.set('appStatus', action.data.activated).set('appStatusCurrency', action.data.currency_status);
    case types.SET_SHOP_SETTINGS_TRANSLATE:
      if (action.dataCurrency.status_charge === 'cancelled') {
        action.data.translate_status = false;
      }
      return state.set('appStatusTranslate', action.data.translate_status);
    default:
      return state;
  }
};

export default appReducer;
